// extracted by mini-css-extract-plugin
export var author = "glossary-intro-module--author--34947";
export var category = "glossary-intro-module--category--88756";
export var headline = "glossary-intro-module--headline--f675b";
export var headlinePost = "glossary-intro-module--headline-post--25f68";
export var pageIntro = "glossary-intro-module--page-intro--630c9";
export var pageIntro__headline = "glossary-intro-module--page-intro__headline--2a68f";
export var pageIntro__image = "glossary-intro-module--page-intro__image--ec10d";
export var pageIntro__imageContainer = "glossary-intro-module--page-intro__imageContainer--69be1";
export var pageIntro__text = "glossary-intro-module--page-intro__text--2c697";
export var pageIntro__textContainer = "glossary-intro-module--page-intro__textContainer--2e915";
export var paragraph = "glossary-intro-module--paragraph--1f11c";